<p-table 
    [value]="items()" 
    size="small" 
    [rowHover]="true" 
    (onSort)="sort($event)" 
    [lazy]="true" 
    [sortField]="sorting().orderByClause" 
    [sortOrder]="sorting().orderDirection === 'asc' ? 1 : -1">

    <ng-template pTemplate="header">
        <tr>
            <th style="width: 2rem;"></th>
            <th pSortableColumn="accounting_date">Data Contabile <p-sortIcon field="accounting_date" /></th>
            <th pSortableColumn="short_description">Titolo <p-sortIcon field="short_description" /></th>
            <th pSortableColumn="fin_wallet_id">Wallet <p-sortIcon field="fin_wallet_id" /></th>
            <th pSortableColumn="etiquette_id">Etichetta <p-sortIcon field="etiquette_id" /></th>
            <th pSortableColumn="amount" style="text-align: right;">Importo <p-sortIcon field="amount" /></th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-trade>
        <tr (click)="onSelect.emit(trade)" class="cursor-pointer">
             <td class="text-center">
                @if(trade.finTradeTypeId === 1 ){
                    <i class="pi pi-arrow-up text-green-500"></i>
                }@else if(trade.finTradeTypeId === 2){
                    <i class="pi pi-arrow-down text-red-500"></i>
                }@else if(trade.finTradeTypeId === 3){
                    <i class="pi pi-equals"></i>
                }@else if(trade.finTradeTypeId === 4 && trade.amount>=0){
                    <i class="pi pi-arrow-up-right text-green-500"></i>
                }@else if(trade.finTradeTypeId === 4 && trade.amount<0){
                    <i class="pi pi-arrow-down-right text-red-500"></i>
                }@else {
                    <i class="pi pi-equals"></i>
                }                
            </td>
            <td>
                <div>{{ trade.accountingDate | date:'dd/MM/yyyy' }}</div>
                <small class="text-secondary">{{ monthNames[trade.accountingMonth - 1] | uppercase}}</small>
            </td>

            <td>
                <div class="font-bold">{{ trade.shortDescription }}</div>
                <div class="text-sm text-overflow-ellipsis">{{ trade.description }}</div>
            </td>
            <td>
                  <div>
                    <i class="pi pi-wallet mr-1 text-xs"></i>
                    {{ walletStore.findReactive(trade.finWalletId)()?.shortDescription ?? 'N/D' }}
                </div>
            </td>
            <td>
              
                <div>
                    <p-tag 
                        [value]="etiquetteStore.findReactive(trade.etiquetteId)()?.shortDescription ?? 'Nessuna'" 
                        severity="secondary" 
                        [rounded]="true">
                    </p-tag>
                </div>
            </td>

            <td class="text-right font-bold" [ngClass]="{'text-green-600': trade.amount > 0, 'text-red-600': trade.amount < 0}" style="text-align: right;">
                {{ trade.amount | currency:'EUR':'symbol':'1.2-2' }}
            </td>

        </tr>
    </ng-template>
</p-table>